module.exports = __webpack_public_path__ + "static/media/alimo.6409ab60.md";